// src/app/pages/about/about.component.ts

import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { SeoService } from '../../services/seo.service';

@Component({
  selector: 'app-about',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule
  ],
  templateUrl: './about.component.html',
  styleUrls: ['./about.component.css']
})
export class AboutComponent implements OnInit {

  constructor(private seo: SeoService) {}

  ngOnInit(): void {

    this.seo.update(
      'About Lydia Christensen',
      'Lydia Christensen is an American politician from Michigan and a Libertarian candidate for the United States Senate in 2026. Learn about Lydia Christensen, her background, and her campaign.',
      'about'
    );

    this.seo.setStructuredData({
      '@context': 'https://schema.org',

      '@type': 'ProfilePage',

      '@id':
        'https://www.lydialynnchristensen.com/about#profile',

      'url':
        'https://www.lydialynnchristensen.com/about',

      'name':
        'About Lydia Christensen',

      'description':
        'Information about Lydia Christensen, an American politician from Michigan and a Libertarian candidate for the United States Senate in 2026.',

      'isPartOf': {
        '@id': this.seo.websiteId
      },

      'mainEntity': {
        '@type': 'Person',

        '@id': this.seo.lydiaId,

        'name': 'Lydia Christensen',

        'url':
          'https://www.lydialynnchristensen.com/about',

        'image': [
          'https://www.lydialynnchristensen.com/assets/lydia-christensen.jpg',
          'https://www.lydialynnchristensen.com/assets/lydia-christensen-campaign.jpg',
          'https://www.lydialynnchristensen.com/assets/lydia-christensen-gothic.jpg',
          'https://www.lydialynnchristensen.com/assets/lydia-christensen-nicer.jpg',
          'https://www.lydialynnchristensen.com/assets/lydia-christensen-puppy.jpg'
        ],

        'jobTitle':
          'Candidate for the United States Senate',

        'description':
          'Lydia Christensen is an American politician from Michigan and a Libertarian candidate for the United States Senate in 2026.',

        'memberOf': {
          '@id': this.seo.campaignId
        },

        'sameAs': [
          'https://www.facebook.com/lydiaforussenate',
          'https://x.com/lydia4ussenate',
          'https://www.tiktok.com/@lydiaforussenate',
          'https://bsky.app/profile/lydiaforussenate.bsky.social',
          'https://www.youtube.com/@LydiaChristensen',
          'https://www.linkedin.com/in/lydialynn'
        ]
      }
    });
  }
}